import { Component, ElementRef, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { BaseInjectorService } from 'src/app/base/base-service.injector';
import { TreasurehuntService } from 'src/app/services/treasureHunt/treasurehunt.service';
import { interval, animationFrameScheduler, Subject, timer } from 'rxjs';
import { takeUntil, tap, take } from 'rxjs/operators';
import * as moment from 'moment-timezone';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { WinnersSplashScreenPage } from 'src/app/pages/treasure_hunt/winners-splash-screen/winners-splash-screen.page';
import { ModalController } from '@ionic/angular';
import { TH_BUBBLE_ANNOYED, TH_BUBBLE_COIN_DROP } from 'src/app/pages/treasure_hunt/th_sounds';
import { HUNTS } from 'src/app/pages/treasure_hunt/th_constants';
import { TreasureHuntLeaderboardPage } from 'src/app/pages/treasure_hunt/treasure-hunt-leaderboard/treasure-hunt-leaderboard.page';
import { ThStoryPage } from 'src/app/pages/treasure_hunt/th-story/th-story.page';
import { AppService } from 'src/app/app.service';
import { LeagueService } from 'src/app/services/league/league.service';
import { LeaderboardOverallComponent } from '../../leaderboard-overall/leaderboard-overall.component';
import { CoinFallPopupAnimationComponent } from '../coin-fall-popup-animation/coin-fall-popup-animation.component';
import {
  bannerTextAnimation,
  chatHeadAnimation,
  chatHeadMoveAnimation,
  teamInfoAnimation,
  toggleOptions,
} from './thbanner-bubble.animations';

@Component({
  selector: 'th-banner-bubble',
  templateUrl: './thbanner-bubble.component.html',
  styleUrls: ['./thbanner-bubble.component.scss'],
  animations: [
    chatHeadAnimation,
    teamInfoAnimation,
    bannerTextAnimation,
    toggleOptions,
    chatHeadMoveAnimation,
  ],
  standalone: false,
})
export class THBannerBubbleComponent extends BaseInjectorService implements OnInit, AfterViewInit {
  isVisible: boolean = false;
  @ViewChild('chatHead', { static: true }) chatHead: ElementRef;
  @ViewChild(ThStoryPage) storyPage!: ThStoryPage;
  private touchStart = { x: 0, y: 0 };
  bannerText: any;
  chatHeadState: string = 'initial';

  showTeamInfo: boolean = false;
  showBannerText: boolean = true;
  animateViewText: string;
  showPlayIcon: boolean = false;

  showTHchest: boolean = false;
  showMysteryBox: boolean = false;
  showLeaderBoard: boolean = false;
  showMysterBoxBannerText: string;

  showBTNOptions: boolean = false;

  userTeamName: any;
  userHuntType: any;

  private audio = new Audio();

  private originalPosition = { x: window.innerWidth - 50, y: window.innerHeight - 150 };
  private currentPos = { ...this.originalPosition };
  private velocity = { x: 10, y: 10 }; // Increased speed by 5x
  private moving = new Subject<void>();
  private lastTapTime = 0;
  private tapCount = 0;
  private tapThreshold = 300;
  isFixedLeft: boolean = false;
  countDownDate: any;
  MysteryBoxDate: string;
  formatedate: moment.Moment;
  countDownDays: number;

  constructor(
    private thService: TreasurehuntService,
    private modal: ModalController,
    private appService: AppService,
    private leagueService: LeagueService
  ) {
    super();
  }

  ngAfterViewInit() {
    this.initDrag();
    this.treasureHuntAPICall();
  }

  ngOnInit() {}

  initDrag() {
    const element = this.chatHead.nativeElement;
    let animationTriggered = false; // Flag to track if the animation has been triggered

    const touchStartHandler = (event) => {
      this.touchStart.x = event.touches[0].clientX;
      this.touchStart.y = event.touches[0].clientY;
      element.classList.remove('fixed-right', 'fixed-left'); // Remove classes at the start of touch
      animationTriggered = false; // Reset the flag at the start of touch
    };

    const touchMoveHandler = (event) => {
      event.preventDefault();

      const deltaX = event.touches[0].clientX - this.touchStart.x;
      const deltaY = event.touches[0].clientY - this.touchStart.y;

      this.currentPos.x += deltaX;
      this.currentPos.y += deltaY;

      // Boundary checks
      const minX = 0;
      const maxX = window.innerWidth - element.offsetWidth;
      const minY = 0;
      const maxY = window.innerHeight - element.offsetHeight;

      if (this.currentPos.x < minX) this.currentPos.x = minX;
      if (this.currentPos.x > maxX) this.currentPos.x = maxX;
      if (this.currentPos.y < minY) this.currentPos.y = minY;
      if (this.currentPos.y > maxY) this.currentPos.y = maxY;

      element.style.left = `${this.currentPos.x}px`;
      element.style.top = `${this.currentPos.y}px`;

      this.touchStart.x = event.touches[0].clientX;
      this.touchStart.y = event.touches[0].clientY;

      // Check if the element is in the center at the bottom 100px by 100px area
      if (
        !animationTriggered &&
        this.bannerText === this.translate.instant('TREASURE_HUNT.COMING_SOON')
      ) {
        const centerX = window.innerWidth / 2;
        const centerBottomY = window.innerHeight - 100;
        const elementCenterX = this.currentPos.x + element.offsetWidth / 2;
        const elementCenterY = this.currentPos.y + element.offsetHeight / 2;

        console.log(
          elementCenterX,
          centerX,
          Math.abs(elementCenterX - centerX),
          Math.abs(elementCenterY - centerBottomY)
        );

        if (
          Math.abs(elementCenterX - centerX) <= 50 &&
          Math.abs(elementCenterY - centerBottomY) <= 50
        ) {
          this.showCoinAnimation();
          animationTriggered = true; // Set the flag to true after triggering the animation
        }
      }
    };

    const touchEndHandler = () => {
      const toRight = window.innerWidth - this.currentPos.x < this.currentPos.x;
      const finalX = toRight ? window.innerWidth - element.offsetWidth : 0;

      this.currentPos.x = finalX;

      element.style.left = `${this.currentPos.x}px`;
      element.style.transition = 'left 0.3s';
      setTimeout(() => (element.style.transition = ''), 300);

      // Add class based on final position
      if (toRight) {
        this.isFixedLeft = false;
        element.classList.add('fixed-right');
        element.classList.remove('fixed-left');
      } else {
        this.isFixedLeft = true;
        element.classList.add('fixed-left');
        element.classList.remove('fixed-right');
      }
    };

    element.addEventListener('touchstart', touchStartHandler);
    element.addEventListener('touchmove', touchMoveHandler);
    element.addEventListener('touchend', touchEndHandler);

    // Cleanup event listeners on component destroy
    this.moving.pipe(takeUntil(this.moving)).subscribe(() => {
      element.removeEventListener('touchstart', touchStartHandler);
      element.removeEventListener('touchmove', touchMoveHandler);
      element.removeEventListener('touchend', touchEndHandler);
    });
  }

  async treasureHuntAPICall() {
    this.thService.getTreasureHuntInfo().then(async (res: any) => {
      if (res.hunt_status=="IN-PROGRESS") {
        this.isVisible = true;
        this.showMysteryBox = false;
        this.showTHBubbleTexts(res);
      }
    });
  }

  async showTHBubbleTexts(data: any) {
    this.thService.TreasureHuntinfo = data;
    let startDate = (moment as any)
      .default(data.start_date)
      .tz(this.thService.TreasureHuntinfo['timezone']);
    let currentDt = (moment as any).default().tz(this.thService.TreasureHuntinfo['timezone']);

    data.isTreasureHuntEnabled = data.active == 'active' ? true : false;

    this.thService.getTeamDetails(data.treasure_hunt_id).then(async (res: any) => {
      await this.lhStorage.set('treasureHunt', this.thService.TreasureHuntinfo);
      if (res) {
        if (res.active) {
          this.userTeamName = res.team_name;
        } else {
          this.userTeamName = 'Waiting';
        }
        this.userHuntType = res.huntType;
        this.userHuntType = HUNTS.find((type: any) => type.key == res.huntType);
      }

      this.appService.lastChatActivityTimeUpdate();
    });

    if (currentDt.format('YYYY-MM-DD') < startDate.format('YYYY-MM-DD')) {
      let countDownDate = (moment as any)
        .default(data.start_date)
        .tz(this.thService.TreasureHuntinfo['timezone'])
        .subtract(data.count_down_days, 'days');
      if (countDownDate.format('YYYY-MM-DD') <= currentDt.format('YYYY-MM-DD')) {
        this.animateViewText = this.translate.instant('TREASURE_HUNT.TREASURE_HUNT-CREATE_OR_JOIN');
        this.bannerText = this.translate.instant('TREASURE_HUNT.TREASURE_HUNT_TO_GO', {
          no: startDate.diff(currentDt, 'days') + 1,
        });
        this.showTHchest = false;
        this.animateElements();
      } else {
        this.bannerText = this.translate.instant('TREASURE_HUNT.COMING_SOON');
      }
      console.log(this.thService.TreasureHuntinfo);
      this.thService.TreasureHuntinfo['isCurrentlyRunning'] = false;
      //await this.lhStorage.set('treasureHunt', this.thService.TreasureHuntinfo);
    } else {
      let thLastDate = (moment as any)
        .default(data.start_date)
        .tz(this.thService.TreasureHuntinfo['timezone'])
        .add(data.no_of_days, 'days');
      let countDownForEnd = (moment as any)
        .default(thLastDate)
        .tz(this.thService.TreasureHuntinfo['timezone'])
        .subtract(data.count_down_for_end, 'days');

      let endFlowEndDate = (moment as any)
        .default(thLastDate)
        .tz(this.thService.TreasureHuntinfo['timezone'])
        .add(data.end_flow_days, 'days');

      if (thLastDate.format('YYYY-MM-DD') <= currentDt.format('YYYY-MM-DD')) {
        let alreadySubmitted = await this.lhStorage.get('mystery_box_submitted');

        if (!alreadySubmitted && Number(endFlowEndDate.diff(currentDt, 'days')) > 0) {
          this.showTHchest = false;
          this.isVisible = false;

          if (this.thService.TreasureHuntinfo['showEndFlow']) {
            this.thService.getTeamDetails(data.treasure_hunt_id).then(async (res: any) => {
              await this.lhStorage.set('treasureHunt', this.thService.TreasureHuntinfo);
              if (res) {
                let teamDetails = res;
                if (teamDetails.id) {
                  this.thService.checkFindingExists(teamDetails.id).then((res) => {
                    if (res) {
                      this.showMysteryBox = true;
                    } else {
                      this.showMysteryBox = false;
                    }
                  });
                } else {
                  this.showMysteryBox = false;
                }
              }

              this.appService.lastChatActivityTimeUpdate();
            });
          } else {
            this.showMysteryBox = false;
          }
          this.showMysterBoxBannerText = this.translate.instant(
            'TREASURE_HUNT.TREASURE_HUNT_MYSTERY_BOX_TO_END',
            { no: Number(endFlowEndDate.diff(currentDt, 'days')) }
          );
        } else {
          this.showTHchest = false;
          this.isVisible = false;
          this.showMysteryBox = false;
        }
      } else {
        this.showBannerText = false;
        this.showTeamInfo = false;
        if (countDownForEnd.format('YYYY-MM-DD') <= currentDt.format('YYYY-MM-DD')) {
          this.showTHchest = true;
          this.showLeaderBoard = true;
          this.showPlayIcon = false;
          this.bannerText = this.translate.instant('TREASURE_HUNT.TREASURE_HUNT_TO_END', {
            no: Number(thLastDate.diff(currentDt, 'days')),
          });
        } else {
          this.showTHchest = true;
          this.showPlayIcon = true;
          this.showLeaderBoard = true;
          this.bannerText = this.translate.instant('BOG_TOUR.BTN_PLAY');
        }
        this.thService.TreasureHuntinfo['isCurrentlyRunning'] = true;
      }
    }
  }

  animateElements() {
    setInterval(() => {
      this.chatHeadState = 'moved';
      this.showTeamInfo = true;
      setTimeout(() => {
        this.chatHeadState = 'initial';
        this.showTeamInfo = false;
      }, 3000);
    }, 8000);
  }

  async showSplashPopup() {
    this.thService.updateSoryStartStage(false);
    //this.thService.updateSoryEndStage(false);
    this.showStoryPagePopup();
    const modal = await this.modal.create({
      component: WinnersSplashScreenPage,
      cssClass: 'th-splash',
      backdropDismiss: true,
      componentProps: {},
    });
    modal.onDidDismiss().then(async () => {
      setTimeout(() => {
        // this.thService.updateSoryStartStage(true);
      }, 300);

      if (this.userTeamName) {
        this.thService.TreasureHuntinfo['hunt_team'] = this.thService.TreasureHuntinfo['hunt_team'];
        await this.lhStorage.set('treasureHunt', this.thService.TreasureHuntinfo);
        if (this.thService.TreasureHuntinfo['hunt_team'].active) {
          this.router.navigate(['/treasure-hunt-dashboard'], { replaceUrl: true });
        } else {
          this.router.navigate(['/team-registration-flow'], { replaceUrl: true });
        }
      } else {
        this.router.navigate(['/team-registration-flow'], { replaceUrl: true });
      }
    });
    setTimeout(() => {
      // modal.dismiss();
    }, 40000);

    return await modal.present();
  }

  async showStoryPagePopup() {
    const storyModal = await this.modal.create({
      component: ThStoryPage,
      cssClass: '',
      backdropDismiss: true,
      componentProps: {},
    });
    storyModal.onDidDismiss().then(() => {
      setTimeout(() => {
        // this.thService.updateSoryEndStage(true);
      }, 300);
    });

    return await storyModal.present();
  }

  async playTH() {
    if (this.bannerText != this.translate.instant('TREASURE_HUNT.COMING_SOON')) {
      if (this.thService.TreasureHuntinfo['hunt_team'] && this.showPlayIcon) {
        this.thService.TreasureHuntinfo['huntAlreadyStarted'] = true;
        this.thService.TreasureHuntinfo['isfromDashboard'] = true;
        this.thService.TreasureHuntinfo['isTeamEdit'] = false;
        this.thService.TreasureHuntinfo['huntTeamDetails'] = {};
        this.thService.TreasureHuntinfo['selectedTeamMembers'] = [];
        this.thService.TreasureHuntinfo['hunt_team'] = this.thService.TreasureHuntinfo['hunt_team'];
        await this.lhStorage.set('treasureHunt', this.thService.TreasureHuntinfo);

        this.router.navigate(['/treasure-hunt-dashboard'], { replaceUrl: true });
      } else {
        this.showSplashPopup();
        // this.router.navigate(["/th-story"], { replaceUrl: true });
      }
    }
  }

  async starttreasurehunt() {
    if (this.bannerText == this.translate.instant('TREASURE_HUNT.COMING_SOON')) {
      return;
    } else {
      this.showOptions();
      return;
    }
  }

  showOptions() {
    this.showBTNOptions = !this.showBTNOptions;
  }

  onBubbleTap() {
    if (this.bannerText == this.translate.instant('TREASURE_HUNT.COMING_SOON')) {
      const currentTime = Date.now();
      if (currentTime - this.lastTapTime < this.tapThreshold) {
        this.tapCount++;
      } else {
        this.tapCount = 1;
      }
      this.lastTapTime = currentTime;

      if (this.tapCount === 1) {
        timer(300)
          .pipe(take(1))
          .subscribe(() => {
            if (this.tapCount === 1) {
              // Single tap confirmed
              this.starttreasurehunt();
            }
          });
      } else if (this.tapCount > 1) {
        this.startMovingRandomly();
      }
    } else {
      this.starttreasurehunt();
    }
  }

  async playTHClick() {
    this.showBTNOptions = false;
    setTimeout(() => {
      this.showSplashPopup();
      //this.router.navigate(["/treasure-hunt-team-selection"], { replaceUrl: true });
    }, 500);
  }

  startMovingRandomly() {
    this.moving.next(); // Reset any existing movement before starting new
    this.setRandomDirection();
    this.moveAround();
    this.audio.src = TH_BUBBLE_ANNOYED;
    this.playMusic();
    setTimeout(() => {
      this.stopMusic();
      this.moving.next(); // Signal to stop moving
      this.resetPosition();
    }, 4000); // Move for 4 seconds before resetting
  }

  setRandomDirection() {
    const speed = 20; // Increased speed by 5x for more noticeable movement
    const angle = Math.random() * 2 * Math.PI;
    this.velocity.x = Math.cos(angle) * speed;
    this.velocity.y = Math.sin(angle) * speed;
  }

  moveAround() {
    const element = this.chatHead.nativeElement;
    interval(10, animationFrameScheduler)
      .pipe(
        takeUntil(this.moving),
        tap(() => {
          this.currentPos.x += this.velocity.x;
          this.currentPos.y += this.velocity.y;

          // Handle boundary collisions
          if (
            this.currentPos.x <= 0 ||
            this.currentPos.x >= window.innerWidth - element.offsetWidth
          ) {
            this.velocity.x = -this.velocity.x;
            this.currentPos.x = Math.max(
              0,
              Math.min(this.currentPos.x, window.innerWidth - element.offsetWidth)
            );
          }
          if (
            this.currentPos.y <= 0 ||
            this.currentPos.y >= window.innerHeight - element.offsetHeight
          ) {
            this.velocity.y = -this.velocity.y;
            this.currentPos.y = Math.max(
              0,
              Math.min(this.currentPos.y, window.innerHeight - element.offsetHeight)
            );
          }

          element.style.left = `${this.currentPos.x}px`;
          element.style.top = `${this.currentPos.y}px`;
        })
      )
      .subscribe();
  }

  resetPosition() {
    const element = this.chatHead.nativeElement;
    element.style.transition = 'left 1s ease-in-out, top 1s ease-in-out';
    // Reset to specific fixed position at the bottom-right
    element.style.left = `calc(100% - ${element.offsetWidth + 20}px)`;
    element.style.top = `calc(100% - ${element.offsetHeight + 80}px)`;

    setTimeout(() => {
      element.style.transition = ''; // Clear transition
      this.currentPos = { ...this.originalPosition };
      this.initDrag(); // Reinitialize dragging after reset
    }, 1000); // Match the timeout duration with the transition duration
  }

  playMusic() {
    this.audio.play().catch((error) => console.error('Error playing audio:', error));
  }

  stopMusic() {
    this.audio.pause();
    this.audio.currentTime = 0; // Reset to start
  }

  async openLeague() {
    if (this.bannerText != this.translate.instant('TREASURE_HUNT.COMING_SOON')) {
      this.router.navigate(['leagues']);
    }
  }

  async showCoinAnimation() {
    this.audio.src = TH_BUBBLE_COIN_DROP;
    this.playMusic();
    const modal = await this.modal.create({
      component: CoinFallPopupAnimationComponent,
      cssClass: 'th-coin-animation',
      backdropDismiss: true,
      componentProps: {},
    });
    modal.onDidDismiss().then(() => {});

    setTimeout(() => {
      modal.dismiss();
      this.stopMusic();
    }, 3000);

    return await modal.present();
  }

  async THleaderboard() {
    this.router.navigate(['/treasure-hunt-leaderboard'], { replaceUrl: true });
  }

  ionViewDidLeave() {
    this.thService.updateSoryStartStage(false);
  }

  async end_hunt() {
    await this.router.navigate(['/end-hunt-open-mystery-box'], { replaceUrl: true });
  }
}
